import { useEffect,useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';

import useServiceCategoriesQuery from '@/modules/employer/queries/useServiceCategories.query';

import { useGetExpressSetupByIdQuery } from '../queries';
import { getFormattedExpressSetupData } from '../utils';

import useExpressSetupSetter from './useExpressSetupSetter';

const useCurrentExpressSetup = (externalId?: string) => {
  const { handleSetState, handleSetSourceState } = useExpressSetupSetter();
  const { list: serviceCategories } = useServiceCategoriesQuery();
  const { params: { id } } = useRouteMatch<{ id: string }>();
  const {
    data, isSuccess, refetch, isLoading, clearCache,
  } = useGetExpressSetupByIdQuery(externalId || id);

  const expressSetup = useMemo(() => getFormattedExpressSetupData(data, serviceCategories), [data, serviceCategories]);

  useEffect(() => {
    if (expressSetup) {
      handleSetSourceState(expressSetup);
      handleSetState(expressSetup);
    }
  }, [isLoading, expressSetup, handleSetSourceState, handleSetState]);

  return {
    data: expressSetup,
    isSuccess,
    isLoading,
    refetch,
    clearCache,
  };
};

export default useCurrentExpressSetup;
